(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-accordion-video-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordionVideo01 extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.visibilityObserver = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.yg-accordion-item');
      }

      get mobileSwiperEnabled() {
        return this.dataset.mobileSwiper === 'true';
      }

      connectedCallback() {
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      loadSlideImages(slide) {
        if (!slide) return;

        const selector = this.isMobileMode
          ? 'img.hide-pc[data-src], img.yg-image:not(.hide-mobile):not(.hide-pc)[data-src]'
          : 'img.hide-mobile[data-src], img.yg-image:not(.hide-mobile):not(.hide-pc)[data-src]';

        slide.querySelectorAll(selector).forEach((img) => {
          const src = img.getAttribute('data-src');
          if (!src) return;

          img.src = src;
          img.removeAttribute('data-src');
        });
      }

      loadCurrentAndNextImages(swiper) {
        if (!swiper || !swiper.slides) return;

        const currentIndex = swiper.activeIndex || 0;
        this.loadSlideImages(swiper.slides[currentIndex]);
        this.loadSlideImages(swiper.slides[currentIndex + 1]);
      }

      observeSwiperVisibility(swiper) {
        if (!swiper) return;

        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
          this.visibilityObserver = null;
        }

        const updateSwiperState = (isVisible) => {
          if (isVisible) {
            this.loadCurrentAndNextImages(swiper);

            if (swiper.autoplay && typeof swiper.autoplay.start === 'function') {
              swiper.autoplay.start();
            }
          } else {
            if (swiper.autoplay && typeof swiper.autoplay.stop === 'function') {
              swiper.autoplay.stop();
            }

            this.items.forEach((item) => {
              this.controlVideo(item, 'pause');
            });
          }
        };

        if (!('IntersectionObserver' in window)) {
          updateSwiperState(true);
          return;
        }

        if (swiper.autoplay && typeof swiper.autoplay.stop === 'function') {
          swiper.autoplay.stop();
        }

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) return;

            updateSwiperState(entry.isIntersecting);
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0.01,
          }
        );

        this.visibilityObserver.observe(this);
      }

      initSwiper() {
        if (this.swiperInstance) return;

        // 如果未开启移动端轮播，则保持原本的移动端堆叠/折叠卡片行为
        if (this.isMobileMode && !this.mobileSwiperEnabled) {
          return;
        }

        if (!this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        if (!galleryContainer) return;

        const pagination = this.querySelector('.yg-accordion-pagination');

        this.swiperInstance = new Swiper(galleryContainer, {
          spaceBetween: 12,
          slidesPerView: 1.2,
          slidesPerGroup: 1,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          watchOverflow: true,
          pagination: {
            el: pagination,
            clickable: true,
          },
          on: {
            init: (swiper) => {
              this.observeSwiperVisibility(swiper);
            },

            slideChange: (swiper) => {
              this.loadCurrentAndNextImages(swiper);

              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });

              // 播放当前活动的 slide 视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            }
          },
          breakpoints: {
            220: {
              slidesPerView: 1.2,
              slidesPerGroup: 1,
              spaceBetween: 12,
            },
          },
        });

        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.visibilityObserver) {
          this.visibilityObserver.disconnect();
          this.visibilityObserver = null;
        }

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 700;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        // 更新当前模式
        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            this.items.forEach((item) => {
              this.controlVideo(item, 'pause');
            });
            if (this.mobileSwiperEnabled) {
              this.initSwiper();
            } else {
              this.destroySwiper();
            }
          } else {
            // 切换到PC端模式
            this.destroySwiper();

            this.items.forEach((item) => {
              this.loadSlideImages(item);
            });

            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        // 标记初始化完成
        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('yg-accordion-video-01')) {
      window.customElements.define('yg-accordion-video-01', YGAccordionVideo01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-tabs-v1"] && !Shopify.designMode) return;
  try {
    
  class YGBannerTabsV1 extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.runInitialSync = this.runInitialSync.bind(this);
      this.initialSyncTimer = null;
    }

    connectedCallback() {
      if (this.isConnectedSetup) return;

      this.isConnectedSetup = true;
      this.waitForSwiper();
    }

    disconnectedCallback() {
      this.tabsContainer?.removeEventListener('click', this.handleTabClick);

      if (this.swiperInstance?.off) {
        this.swiperInstance.off('slideChange', this.handleSlideChange);
        this.swiperInstance.off('slideChangeTransitionEnd', this.handleSlideChange);
      }

      if (this.initialSyncTimer) {
        clearTimeout(this.initialSyncTimer);
        this.initialSyncTimer = null;
      }

      this.isConnectedSetup = false;
      this.isReady = false;
    }

    get swiperElement() {
      return this.querySelector('.yg-banner-swiper');
    }

    get swiperInstance() {
      return this.swiperElement?.swiper;
    }

    get tabsContainer() {
      return this.querySelector('.yg-tabs-title-container');
    }

    get tabs() {
      return Array.from(this.querySelectorAll('.yg-banner-tab-title'));
    }

    get slides() {
      return Array.from(this.querySelectorAll('.yg-banner-swiper .swiper-slide'));
    }

    waitForSwiper(attempt = 0) {
      if (this.isReady) return;

      if (this.swiperInstance) {
        this.initialize();
        return;
      }

      if (attempt > 40) return;

      requestAnimationFrame(() => this.waitForSwiper(attempt + 1));
    }

    initialize() {
      if (this.isReady) return;

      this.isReady = true;
      this.tabsContainer?.addEventListener('click', this.handleTabClick);
      this.swiperInstance?.on('slideChange', this.handleSlideChange);
      this.swiperInstance?.on('slideChangeTransitionEnd', this.handleSlideChange);

      this.defaultIndex = this.slides.length > 2 ? 2 : 0;

      if (this.swiperInstance && this.getActiveIndex() !== this.defaultIndex) {
        this.swiperInstance.slideTo(this.defaultIndex, 0);
      }

      this.runInitialSync();
    }

    runInitialSync(attempt = 0) {
      const activeIndex = typeof this.defaultIndex === 'number' ? this.defaultIndex : 0;

      if (this.swiperInstance && this.getActiveIndex() !== activeIndex) {
        this.swiperInstance.slideTo(activeIndex, 0);
      }

      this.syncActiveTab(activeIndex);

      if (attempt < 10) {
        this.initialSyncTimer = setTimeout(() => this.runInitialSync(attempt + 1), 80);
      }
    }

    getActiveIndex() {
      if (!this.swiperInstance) return 0;
      return typeof this.swiperInstance.realIndex === 'number'
        ? this.swiperInstance.realIndex
        : this.swiperInstance.activeIndex;
    }

    handleTabClick(event) {
      const tab = event.target.closest('.tab-title');
      if (!tab || !this.swiperInstance) return;

      const tabIndex = this.tabs.indexOf(tab);
      if (tabIndex < 0) return;

      this.swiperInstance.slideTo(tabIndex);
      this.syncActiveTab(tabIndex);
    }

    handleSlideChange() {
      const activeIndex = this.getActiveIndex();
      this.syncActiveTab(activeIndex);
    }

    syncActiveTab(index) {
      if (!this.tabsContainer) return;

      const currentTab = this.tabs[index];
      if (!currentTab) return;

      const targetLeft = currentTab.offsetLeft - (this.tabsContainer.clientWidth - currentTab.clientWidth) / 2;
      const maxScrollLeft = this.tabsContainer.scrollWidth - this.tabsContainer.clientWidth;
      const nextScrollLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

      this.tabsContainer.scrollTo({
        left: nextScrollLeft,
        behavior: 'smooth',
      });

      if (typeof this.tabsContainer.toggleClass === 'function') {
        this.tabsContainer.toggleClass(currentTab, index);
        return;
      }

      this.tabs.forEach((tab) => tab.classList.remove('is-active'));
      currentTab.classList.add('is-active');
    }
  }

  if (!window.customElements.get('yg-banner-tabs-v1')) {
    window.customElements.define('yg-banner-tabs-v1', YGBannerTabsV1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-download-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setActiveMenu = (root, menuId) => {
      const menuItems = root.querySelectorAll('[data-menu-id]');
      const panels = root.querySelectorAll('[data-content-id]');

      menuItems.forEach((item) => {
        item.classList.toggle('is-active', item.dataset.menuId === menuId);
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.contentId !== menuId;
      });
    };

    const initRoot = (root) => {
      const firstMenu = root.querySelector('[data-menu-id]');

      if (!firstMenu) {
        return;
      }

      const activeMenu = root.querySelector('[data-menu-id].is-active');
      const menuId = activeMenu ? activeMenu.dataset.menuId : firstMenu.dataset.menuId;

      setActiveMenu(root, menuId);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-yg-download]').forEach((root) => {
        initRoot(root);
      });
    };

    if (!window.__ygDownloadSectionBound) {
      window.__ygDownloadSectionBound = true;

      document.addEventListener('click', (event) => {
        const menuItem = event.target.closest('[data-menu-id]');

        if (!menuItem) {
          return;
        }

        const root = menuItem.closest('[data-yg-download]');

        if (!root) {
          return;
        }

        setActiveMenu(root, menuItem.dataset.menuId);
      });

      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });
    }

    initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-group-01"] && !Shopify.designMode) return;
  try {
    
  class YGMediaGroup01Tabs extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
    }

    connectedCallback() {
      if (this.isConnectedSetup) return;
      this.isConnectedSetup = true;
      this.waitForSwiper();
    }

    disconnectedCallback() {
      this.tabsContainer?.removeEventListener('click', this.handleTabClick);
      if (this.swiperInstance?.off) {
        this.swiperInstance.off('slideChange', this.handleSlideChange);
        this.swiperInstance.off('slideChangeTransitionEnd', this.handleSlideChange);
      }
      this.isConnectedSetup = false;
      this.isReady = false;
    }

    get swiperElement() {
      return this.querySelector('.yg-media-group-01__swiper');
    }

    get swiperInstance() {
      return this.swiperElement?.swiper;
    }

    get tabsContainer() {
      return this.querySelector('.yg-tabs-title-container');
    }

    get tabs() {
      return Array.from(this.querySelectorAll('.yg-media-group-01__tab-title'));
    }

    waitForSwiper(attempt = 0) {
      if (this.isReady) return;
      if (this.swiperInstance) {
        this.initialize();
        return;
      }
      if (attempt > 40) return;
      requestAnimationFrame(() => this.waitForSwiper(attempt + 1));
    }

    initialize() {
      if (this.isReady) return;
      this.isReady = true;
      this.tabsContainer?.addEventListener('click', this.handleTabClick);
      this.swiperInstance?.on('slideChange', this.handleSlideChange);
      this.swiperInstance?.on('slideChangeTransitionEnd', this.handleSlideChange);

      if (this.swiperInstance?.params?.loop && typeof this.swiperInstance.slideToLoop === 'function') {
        this.swiperInstance.slideToLoop(0, 0, false);
      }
      this.syncActiveTab(this.getActiveIndex());
    }

    getActiveIndex() {
      if (!this.swiperInstance) return 0;
      const activeSlide = this.swiperInstance.slides?.[this.swiperInstance.activeIndex];
      const slideIndex = Number(activeSlide?.getAttribute('data-swiper-slide-index'));
      if (!Number.isNaN(slideIndex)) return slideIndex;
      return typeof this.swiperInstance.realIndex === 'number' ? this.swiperInstance.realIndex : this.swiperInstance.activeIndex;
    }

    handleTabClick(event) {
      const tab = event.target.closest('.tab-title');
      if (!tab || !this.swiperInstance) return;
      const tabIndex = this.tabs.indexOf(tab);
      if (tabIndex < 0) return;
      if (this.swiperInstance.params.loop && typeof this.swiperInstance.slideToLoop === 'function') {
        this.swiperInstance.slideToLoop(tabIndex);
      } else {
        this.swiperInstance.slideTo(tabIndex);
      }
      this.syncActiveTab(tabIndex);
    }

    handleSlideChange() {
      this.syncActiveTab(this.getActiveIndex());
    }

    syncActiveTab(index) {
      if (!this.tabsContainer) return;
      const currentTab = this.tabs[index];
      if (!currentTab) return;
      currentTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
      if (typeof this.tabsContainer.toggleClass === 'function') {
        this.tabsContainer.toggleClass(currentTab, index);
        return;
      }
      this.tabs.forEach((tab) => tab.classList.remove('is-active'));
      currentTab.classList.add('is-active');
    }
  }

  if (!window.customElements.get('yg-media-group-01-tabs')) {
    window.customElements.define('yg-media-group-01-tabs', YGMediaGroup01Tabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const resetHtml5VideoProgress = (videoElement) => {
      const html5Videos = videoElement.querySelectorAll('.yg-video-iframe-container video.yg-video-iframe');
      html5Videos.forEach((item) => {
        item.currentTime = 0;
      });
    };

    const initViewportAutoplay = (scope = document) => {
      const mediaElements = scope.querySelectorAll('.yg-media[data-viewport-autoplay="true"]');
      if (!mediaElements.length) return;

      window.__ygMediaViewportAutoplayObservers ||= new WeakMap();

      mediaElements.forEach((mediaElement) => {
        const videoElement = mediaElement.querySelector('yg-video[data-popup="false"]');

        if (
          !videoElement ||
          typeof videoElement.playVideo !== 'function' ||
          typeof videoElement.pauseVideo !== 'function'
        ) {
          return;
        }

        window.__ygMediaViewportAutoplayObservers.get(videoElement)?.disconnect();

        let isInViewport = false;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!isInViewport) {
                  isInViewport = true;
                  resetHtml5VideoProgress(videoElement);
                  videoElement.playVideo();
                }
              } else if (isInViewport) {
                isInViewport = false;
                videoElement.pauseVideo();
              }
            });
          },
          {
            threshold: 0.35,
          }
        );

        observer.observe(videoElement);
        window.__ygMediaViewportAutoplayObservers.set(videoElement, observer);
      });
    };

    const start = (scope = document) => {
      if (window.customElements?.get('yg-video')) {
        initViewportAutoplay(scope);
      } else {
        window.customElements.whenDefined('yg-video').then(() => initViewportAutoplay(scope));
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      start(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v2"] && !Shopify.designMode) return;
  try {
    
  class YGProcessStepsV2 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.mobileSwiper = null;
      this.hoverTimer = null;
      this.handleDesktopStepHover = this.handleDesktopStepHover.bind(this);
      this.handleDesktopTriggerClick = this.handleDesktopTriggerClick.bind(this);
      this.handleMobileNavClick = this.handleMobileNavClick.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        desktopTriggers: this.querySelectorAll('[data-step-trigger]'),
        desktopSteps: this.querySelectorAll('.yg-process-steps-v2-step'),
        desktopMedia: this.querySelectorAll('[data-step-media]'),
        mobileNavButtons: this.querySelectorAll('[data-mobile-nav-button]'),
        mobileSlides: this.querySelectorAll('[data-step-slide]'),
        mobileSwiperElement: this.querySelector('.yg-process-steps-v2-mobile-swiper'),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      this.sectionElements.desktopSteps.forEach((step) => {
        step.addEventListener('mouseenter', this.handleDesktopStepHover);
      });

      this.sectionElements.desktopTriggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleDesktopTriggerClick);
      });

      this.sectionElements.mobileNavButtons.forEach((button) => {
        button.addEventListener('click', this.handleMobileNavClick);
      });

      window.addEventListener('resize', this.handleResize);
      this.bindMobileSwiper();
      this.updateDesktopContentHeights();
      this.setActiveStep(this.activeIndex, { syncSwiper: false, playMedia: false });
      requestAnimationFrame(() => this.playActiveVideo());
    }

    disconnectedCallback() {
      this.sectionElements.desktopSteps.forEach((step) => {
        step.removeEventListener('mouseenter', this.handleDesktopStepHover);
      });

      this.sectionElements.desktopTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', this.handleDesktopTriggerClick);
      });

      this.sectionElements.mobileNavButtons.forEach((button) => {
        button.removeEventListener('click', this.handleMobileNavClick);
      });

      if (this.mobileSwiper?.off) {
        this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
      }

      window.removeEventListener('resize', this.handleResize);
      if (this.hoverTimer) clearTimeout(this.hoverTimer);
      this.pauseAllVideos();
    }

    bindMobileSwiper(retryCount = 12) {
      const swiper = this.sectionElements.mobileSwiperElement?.swiper;

      if (!swiper) {
        if (retryCount > 0) {
          window.setTimeout(() => this.bindMobileSwiper(retryCount - 1), 120);
        }
        return;
      }

      if (this.mobileSwiper === swiper) {
        return;
      }

      this.mobileSwiper = swiper;
      this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
    }

    handleDesktopStepHover(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      if (index === this.activeIndex) return;

      if (this.hoverTimer) clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => {
        this.setActiveStep(index);
      }, 80);
    }

    handleDesktopTriggerClick(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      if (this.hoverTimer) clearTimeout(this.hoverTimer);
      this.setActiveStep(index);
    }

    handleMobileNavClick(event) {
      const index = Number(event.currentTarget.dataset.stepIndex);
      this.setActiveStep(index);
    }

    handleMobileSlideChange() {
      const nextIndex =
        typeof this.mobileSwiper.realIndex === 'number' ? this.mobileSwiper.realIndex : this.mobileSwiper.activeIndex;

      this.setActiveStep(nextIndex, { syncSwiper: false });
    }

    handleResize() {
      this.updateDesktopContentHeights();
    }

    updateDesktopContentHeights() {
      this.querySelectorAll('.yg-process-steps-v2-step-content').forEach((content) => {
        content.style.setProperty('--step-content-height', `${content.scrollHeight}px`);
      });
    }

    setActiveStep(index, options = {}) {
      const stepCount = this.sectionElements.desktopSteps.length || this.sectionElements.mobileSlides.length;

      if (stepCount === 0) {
        return;
      }

      const safeIndex = Math.max(0, Math.min(index, stepCount - 1));
      const syncSwiper = options.syncSwiper !== false;
      const playMedia = options.playMedia !== false;

      this.activeIndex = safeIndex;
      this.updateDesktopContentHeights();

      this.sectionElements.desktopSteps.forEach((step, stepIndex) => {
        const isActive = stepIndex === safeIndex;
        const trigger = step.querySelector('[data-step-trigger]');
        const content = step.querySelector('.yg-process-steps-v2-step-content');

        step.classList.toggle('is-active', isActive);

        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (content) {
          content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        }
      });

      this.sectionElements.desktopMedia.forEach((media, mediaIndex) => {
        media.classList.toggle('is-active', mediaIndex === safeIndex);
      });

      this.sectionElements.mobileNavButtons.forEach((button, buttonIndex) => {
        const isActive = buttonIndex === safeIndex;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (syncSwiper && this.mobileSwiper && window.innerWidth <= 699) {
        const currentIndex =
          typeof this.mobileSwiper.realIndex === 'number' ? this.mobileSwiper.realIndex : this.mobileSwiper.activeIndex;

        if (currentIndex !== safeIndex) {
          this.mobileSwiper.slideTo(safeIndex);
        }
      }

      if (playMedia) {
        this.playActiveVideo();
      }
    }

    pauseAllVideos() {
      this.querySelectorAll('yg-video').forEach((videoElement) => {
        if (typeof videoElement.pauseVideo === 'function') {
          videoElement.pauseVideo();
        }
      });
    }

    playActiveVideo() {
      this.pauseAllVideos();

      let videoElement = null;

      if (window.innerWidth <= 699) {
        videoElement = this.sectionElements.mobileSlides[this.activeIndex]?.querySelector('yg-video');
      } else {
        videoElement = this.sectionElements.desktopMedia[this.activeIndex]?.querySelector('yg-video');
      }

      if (videoElement && typeof videoElement.playVideo === 'function') {
        videoElement.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps-v2')) {
    window.customElements.define('yg-process-steps-v2', YGProcessStepsV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-sticky-story-v1"] && !Shopify.designMode) return;
  try {
    
  class YGStickyStoryV1 extends HTMLElement {
    constructor() {
      super();
      this.handleIntersection = this.handleIntersection.bind(this);
      this.handleVideoVisibility = this.handleVideoVisibility.bind(this);
      this._videoPlaying = false;
    }

    connectedCallback() {
      this.screens = Array.from(this.querySelectorAll('[data-screen]'));

      if (this.screens.length === 0) {
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersection, {
        threshold: [0.2, 0.4, 0.6, 0.8],
      });

      this.screens.forEach((screen) => {
        this.observer.observe(screen);
      });

      this.initVideoVisibilityObserver();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.videoObserver?.disconnect();
    }

    initVideoVisibilityObserver() {
      this.videoEl = this.querySelector('yg-video');
      this.stickyBg = this.querySelector('.yg-sticky-story-v1__background-sticky');
      if (!this.videoEl || !this.stickyBg) return;

      this.videoObserver = new IntersectionObserver(this.handleVideoVisibility, {
        threshold: 0.98,
      });
      this.videoObserver.observe(this.stickyBg);
    }

    handleVideoVisibility(entries) {
      const entry = entries[0];
      if (!entry) return;
      if (!this.videoEl) return;

      if (entry.isIntersecting && !this._videoPlaying) {
        this._videoPlaying = true;
        this.videoEl.playVideo();
        this.videoObserver.disconnect();
      }
    }

    handleIntersection() {
      if (!this.screens || this.screens.length === 0) {
        return;
      }

      let activeScreen = this.screens[0];
      let highestRatio = -1;

      this.screens.forEach((screen) => {
        const rect = screen.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        const ratio = Math.max(0, Math.min(visibleHeight / Math.max(rect.height, 1), 1));

        if (ratio > highestRatio) {
          highestRatio = ratio;
          activeScreen = screen;
        }
      });

      this.screens.forEach((screen) => {
        screen.classList.toggle('is-active', screen === activeScreen);
      });
    }
  }

  if (!window.customElements.get('yg-sticky-story-v1')) {
    window.customElements.define('yg-sticky-story-v1', YGStickyStoryV1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-swiper-tab-01"] && !Shopify.designMode) return;
  try {
    
  class YGSwiperTab01 extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
    }

    connectedCallback() {
      if (this.isConnectedSetup) return;
      this.isConnectedSetup = true;
      this.waitForSwiper();
    }

    disconnectedCallback() {
      this.tabsContainer?.removeEventListener('click', this.handleTabClick);

      if (this.swiperInstance?.off) {
        this.swiperInstance.off('slideChange', this.handleSlideChange);
        this.swiperInstance.off('slideChangeTransitionEnd', this.handleSlideChange);
      }

      this.isConnectedSetup = false;
      this.isReady = false;
    }

    get swiperElement() {
      return this.querySelector('.yg-swiper-tab-01__swiper');
    }

    get swiperInstance() {
      return this.swiperElement?.swiper;
    }

    get tabsContainer() {
      return this.querySelector('.yg-tabs-title-container');
    }

    get tabs() {
      return Array.from(this.querySelectorAll('.yg-swiper-tab-01__tab-title'));
    }

    waitForSwiper(attempt = 0) {
      if (this.isReady) return;

      if (this.swiperInstance) {
        this.initialize();
        return;
      }

      if (attempt > 40) return;
      requestAnimationFrame(() => this.waitForSwiper(attempt + 1));
    }

    initialize() {
      if (this.isReady) return;
      this.isReady = true;

      this.tabsContainer?.addEventListener('click', this.handleTabClick);
      this.swiperInstance?.on('slideChange', this.handleSlideChange);
      this.swiperInstance?.on('slideChangeTransitionEnd', this.handleSlideChange);

      if (this.swiperInstance?.params?.loop && typeof this.swiperInstance.slideToLoop === 'function') {
        this.swiperInstance.slideToLoop(0, 0, false);
      }

      this.syncActiveTab(this.getActiveIndex());
    }

    getActiveIndex() {
      if (!this.swiperInstance) return 0;

      const activeSlide = this.swiperInstance.slides?.[this.swiperInstance.activeIndex];
      const slideIndex = Number(activeSlide?.getAttribute('data-swiper-slide-index'));
      if (!Number.isNaN(slideIndex)) return slideIndex;

      return typeof this.swiperInstance.realIndex === 'number' ? this.swiperInstance.realIndex : this.swiperInstance.activeIndex;
    }

    handleTabClick(event) {
      const tab = event.target.closest('.tab-title');
      if (!tab || !this.swiperInstance) return;

      const tabIndex = this.tabs.indexOf(tab);
      if (tabIndex < 0) return;

      if (this.swiperInstance.params.loop && typeof this.swiperInstance.slideToLoop === 'function') {
        this.swiperInstance.slideToLoop(tabIndex);
      } else {
        this.swiperInstance.slideTo(tabIndex);
      }

      this.syncActiveTab(tabIndex);
    }

    handleSlideChange() {
      this.syncActiveTab(this.getActiveIndex());
    }

    syncActiveTab(index) {
      if (!this.tabsContainer) return;
      const currentTab = this.tabs[index];
      if (!currentTab) return;

      currentTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });

      if (typeof this.tabsContainer.toggleClass === 'function') {
        this.tabsContainer.toggleClass(currentTab, index);
        return;
      }

      this.tabs.forEach((tab) => tab.classList.remove('is-active'));
      currentTab.classList.add('is-active');
    }
  }

  if (!window.customElements.get('yg-swiper-tab-01')) {
    window.customElements.define('yg-swiper-tab-01', YGSwiperTab01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-swiper-tab"] && !Shopify.designMode) return;
  try {
    
  class YGSwiperTab extends YGUtils {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      const swiperEl = this.querySelector('.yg-swiper-tab__swiper');
      if (!swiperEl) return;

      this.swiper = this.initSwiper(swiperEl);
      this.tabEls = Array.from(this.querySelectorAll('.yg-swiper-tab__tab'));
      this.bindTabs();
      this.bindSwiper();
    }

    bindTabs() {
      if (!this.tabEls?.length || !this.swiper) return;

      this.tabEls.forEach((tabEl) => {
        tabEl.addEventListener('click', () => {
          const targetIndex = Number(tabEl.dataset.index);
          if (Number.isNaN(targetIndex)) return;

          if (this.swiper.params.loop && typeof this.swiper.slideToLoop === 'function') {
            this.swiper.slideToLoop(targetIndex);
          } else {
            this.swiper.slideTo(targetIndex);
          }
        });
      });
    }

    bindSwiper() {
      if (!this.swiper || !this.tabEls?.length) return;

      this.syncActive(this.swiper.realIndex || 0);
      this.swiper.on('slideChange', () => {
        this.syncActive(this.swiper.realIndex || 0);
      });
    }

    syncActive(index) {
      this.tabEls.forEach((tabEl, tabIndex) => {
        tabEl.classList.toggle('is-active', tabIndex === index);
      });
    }
  }

  if (!window.customElements.get('yg-swiper-tab')) {
    window.customElements.define('yg-swiper-tab', YGSwiperTab);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-media-beam"] && !Shopify.designMode) return;
  try {
    
  class YGTabsMediaBeam extends HTMLElement {
    constructor() {
      super();
      this.onTabClick = this.onTabClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onSwiperChange = this.onSwiperChange.bind(this);
      this.onInitialViewportIntersect = this.onInitialViewportIntersect.bind(this);
      this.pendingResetSwiperEl = null;
      this.initialAutoplayObserver = null;
      this.hasInitialViewportAutoplayDone = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.boundSwiperEls = new WeakSet();
      this.waitForReady();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      this.titleContainer?.removeEventListener('click', this.onTabClick);
      window.removeEventListener('resize', this.onResize);
      this.disconnectInitialAutoplayObserver();

      this.desktopSwipers.forEach((swiperEl) => {
        if (swiperEl.swiper?.off) {
          swiperEl.swiper.off('slideChange', this.onSwiperChange);
        }
      });
    }

    get titleContainer() {
      return this.querySelector('.yg-tabs-title-container');
    }

    get contentContainer() {
      return this.querySelector('.yg-tabs-content-container');
    }

    get desktopSwipers() {
      return Array.from(this.querySelectorAll('.yg-tabs-media-beam__desktop-swiper'));
    }

    waitForReady(attempt = 0) {
      if (!this.titleContainer || !this.contentContainer) {
        if (attempt < 40) {
          requestAnimationFrame(() => this.waitForReady(attempt + 1));
        }
        return;
      }

      this.titleContainer.addEventListener('click', this.onTabClick);
      this.bindSwiperEvents();
      this.setupInitialViewportAutoplay();
    }

    setupInitialViewportAutoplay() {
      if (this.hasInitialViewportAutoplayDone) return;

      if (!('IntersectionObserver' in window)) {
        this.triggerInitialViewportAutoplay();
        return;
      }

      this.disconnectInitialAutoplayObserver();
      this.initialAutoplayObserver = new IntersectionObserver(this.onInitialViewportIntersect, {
        root: null,
        threshold: 0.3,
      });
      this.initialAutoplayObserver.observe(this);
    }

    disconnectInitialAutoplayObserver() {
      if (!this.initialAutoplayObserver) return;
      this.initialAutoplayObserver.disconnect();
      this.initialAutoplayObserver = null;
    }

    onInitialViewportIntersect(entries) {
      if (this.hasInitialViewportAutoplayDone) return;
      const isVisible = entries.some((entry) => entry.isIntersecting);
      if (!isVisible) return;
      this.triggerInitialViewportAutoplay();
    }

    triggerInitialViewportAutoplay() {
      if (this.hasInitialViewportAutoplayDone) return;
      this.hasInitialViewportAutoplayDone = true;
      this.disconnectInitialAutoplayObserver();
      requestAnimationFrame(() => {
        this.playActiveTab({ resetSwiper: true, restartVideo: true });
      });
    }

    bindSwiperEvents() {
      let allReady = true;

      this.desktopSwipers.forEach((swiperEl) => {
        if (!swiperEl.swiper) {
          allReady = false;
          return;
        }

        if (this.boundSwiperEls.has(swiperEl)) return;

        swiperEl.swiper.on('slideChange', this.onSwiperChange);
        this.boundSwiperEls.add(swiperEl);
      });

      if (!allReady) {
        requestAnimationFrame(() => this.bindSwiperEvents());
      }
    }

    onTabClick(event) {
      const clickedTab = event.target.closest('.tab-title');
      if (!clickedTab) return;
      if (clickedTab.classList.contains('is-active')) return;
      this.hasInitialViewportAutoplayDone = true;
      this.disconnectInitialAutoplayObserver();

      requestAnimationFrame(() => {
        this.playActiveTab({ resetSwiper: true, restartVideo: true });
      });
    }

    onResize() {
      this.playActiveTab({ resetSwiper: false, restartVideo: false });
    }

    onSwiperChange(event) {
      const swiperEl = event?.el?.closest('.yg-tabs-media-beam__desktop-swiper');
      if (!swiperEl?.closest('.tab-content')?.classList.contains('is-active')) return;

      if (this.pendingResetSwiperEl && this.pendingResetSwiperEl !== swiperEl) return;

      this.pendingResetSwiperEl = null;
      this.pauseAllVideos({ reset: false });
      this.playVideosInContainer(swiperEl, { restart: true });
    }

    playActiveTab({ resetSwiper = false, restartVideo = false } = {}) {
      const activeContent =
        this.contentContainer.querySelector('.tab-content.is-active') || this.contentContainer.firstElementChild;
      if (!activeContent) return;

      this.pauseAllVideos({ reset: false });

      const desktopSwiper = activeContent.querySelector('.yg-tabs-media-beam__desktop-swiper');
      if (desktopSwiper?.swiper) {
        desktopSwiper.swiper.update();

        if (resetSwiper && desktopSwiper.swiper.activeIndex != 0) {
          this.pendingResetSwiperEl = desktopSwiper;
          desktopSwiper.swiper.slideTo(0, 0, false);
          return;
        }

        if (resetSwiper) {
          this.pendingResetSwiperEl = null;
          desktopSwiper.swiper.slideTo(0, 0, false);
        }
      }

      this.playVideosInContainer(activeContent, { restart: restartVideo });
    }

    pauseAllVideos({ reset = false } = {}) {
      this.querySelectorAll('yg-video').forEach((videoBox) => {
        this.setVideoBoxIdleState(videoBox);
      });

      this.querySelectorAll('video').forEach((video) => {
        try {
          video.pause();
          if (reset) video.currentTime = 0;
        } catch (error) {}
      });
    }

    playVideosInContainer(container, { restart = false } = {}) {
      if (!container) return;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      let videoBoxes = [];

      if (isMobile) {
        videoBoxes = Array.from(container.querySelectorAll('.yg-tabs-media-beam__mobile yg-video'));
      } else {
        const activeSlide = container.querySelector('.yg-tabs-media-beam__desktop .swiper-slide-active');
        videoBoxes = Array.from(activeSlide?.querySelectorAll('yg-video') || []);
      }

      videoBoxes.forEach((videoBox) => {
        const mediaContainer = this.ensureVideoContainer(videoBox);
        const videos = Array.from(mediaContainer?.querySelectorAll('video') || []);
        let hasRevealed = false;
        const revealMedia = () => {
          if (hasRevealed) return;
          hasRevealed = true;
          this.setVideoBoxPlayingState(videoBox);
        };

        this.setVideoBoxIdleState(videoBox);

        videos.forEach((video) => this.playVideoOnce(video, isMobile, { restart, onReady: revealMedia }));
      });
    }

    ensureVideoContainer(videoBox) {
      let mediaContainer = videoBox.querySelector('.yg-video-iframe-container');

      if (!mediaContainer) {
        const template = videoBox.querySelector('template');
        if (template) {
          videoBox.appendChild(template.content.cloneNode(true));
          mediaContainer = videoBox.querySelector('.yg-video-iframe-container');
        }
      }

      return mediaContainer;
    }

    setVideoBoxIdleState(videoBox) {
      if (!videoBox) return;
      videoBox.querySelector('.yg-video-placeholder')?.classList.remove('close');
      videoBox.querySelector('.yg-video-button')?.classList.add('hide');
      videoBox.querySelector('.yg-video-iframe-container')?.classList.add('close');
    }

    setVideoBoxPlayingState(videoBox) {
      if (!videoBox) return;
      videoBox.querySelector('.yg-video-placeholder')?.classList.add('close');
      videoBox.querySelector('.yg-video-button')?.classList.add('hide');
      videoBox.querySelector('.yg-video-iframe-container')?.classList.remove('close');
    }

    playVideoOnce(video, isMobile, { restart = false, onReady } = {}) {
      if (video.classList.contains('hide-mobile') && isMobile) return;
      if (video.classList.contains('hide-pc') && !isMobile) return;

      video.controls = false;
      video.loop = false;
      video.muted = true;
      video.playsInline = true;
      video.removeAttribute('controls');

      if (!video.dataset.ygTabsMediaBeamBound) {
        video.dataset.ygTabsMediaBeamBound = 'true';
        video.addEventListener('ended', () => {
          try {
            video.pause();
          } catch (error) {}
        });
      }

      try {
        video.pause();
        if (restart) {
          video.currentTime = 0;
        }

        if (typeof onReady === 'function') {
          video.addEventListener('playing', onReady, { once: true });
          video.addEventListener('loadeddata', onReady, { once: true });
        }

        const playPromise = video.play();
        if (playPromise?.catch) {
          playPromise.catch(() => {});
        }
      } catch (error) {}
    }
  }

  if (!window.customElements.get('yg-tabs-media-beam')) {
    window.customElements.define('yg-tabs-media-beam', YGTabsMediaBeam);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-video"] && !Shopify.designMode) return;
  try {
    
  class YGTabsVideo extends HTMLElement {
    constructor() {
      super();
      this.onTabClick = this.onTabClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.handleSwiperChange = this.handleSwiperChange.bind(this);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.boundSwiperEls = new WeakSet();
      this.waitForReady();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      this.titleContainer?.removeEventListener('click', this.onTabClick);
      window.removeEventListener('resize', this.onResize);

      this.desktopSwipers.forEach((swiperEl) => {
        if (swiperEl.swiper?.off) {
          swiperEl.swiper.off('slideChange', this.handleSwiperChange);
        }
      });

      this.initialized = false;
    }

    get titleContainer() {
      return this.querySelector('.yg-tabs-title-container');
    }

    get contentContainer() {
      return this.querySelector('.yg-tabs-content-container');
    }

    get desktopSwipers() {
      return Array.from(this.querySelectorAll('.yg-tabs-video__desktop-swiper'));
    }

    waitForReady(attempt = 0) {
      if (!this.titleContainer || !this.contentContainer) {
        if (attempt < 40) {
          requestAnimationFrame(() => this.waitForReady(attempt + 1));
        }
        return;
      }

      this.bindEvents();
      this.bindSwiperEvents();
      this.activateCurrentTab({ resetSwiper: true });
    }

    bindEvents() {
      if (this.eventsBound) return;
      this.eventsBound = true;
      this.titleContainer.addEventListener('click', this.onTabClick);
    }

    bindSwiperEvents() {
      let allReady = true;

      this.desktopSwipers.forEach((swiperEl) => {
        if (!swiperEl.swiper) {
          allReady = false;
          return;
        }

        if (this.boundSwiperEls.has(swiperEl)) return;

        swiperEl.swiper.on('slideChange', this.handleSwiperChange);
        this.boundSwiperEls.add(swiperEl);
      });

      if (!allReady) {
        requestAnimationFrame(() => this.bindSwiperEvents());
      }
    }

    onTabClick(event) {
      const tab = event.target.closest('.tab-title');
      if (!tab) return;

      requestAnimationFrame(() => {
        this.activateCurrentTab({ resetSwiper: true });
      });
    }

    onResize() {
      this.activateCurrentTab({ resetSwiper: false });
    }

    handleSwiperChange(event) {
      const swiperRoot = event?.el?.closest('.yg-tabs-video__desktop-swiper');
      if (!swiperRoot) return;

      if (!swiperRoot.closest('.tab-content')?.classList.contains('is-active')) return;
      this.playVideosInContainer(swiperRoot);
    }

    activateCurrentTab({ resetSwiper = false } = {}) {
      const activeContent = this.contentContainer.querySelector('.tab-content.is-active') || this.contentContainer.firstElementChild;
      if (!activeContent) return;

      this.pauseAllVideos();

      const desktopSwiper = activeContent.querySelector('.yg-tabs-video__desktop-swiper');
      if (desktopSwiper?.swiper) {
        desktopSwiper.swiper.update();

        if (resetSwiper) {
          desktopSwiper.swiper.slideTo(0, 0, false);
        }
      }

      this.playVideosInContainer(activeContent);
    }

    pauseAllVideos() {
      this.querySelectorAll('video').forEach((video) => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {}
      });
    }

    playVideosInContainer(container) {
      if (!container) return;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      let videos = [];

      if (isMobile) {
        videos = Array.from(container.querySelectorAll('.yg-tabs-video__mobile video'));
      } else {
        const activeSlide = container.querySelector('.yg-tabs-video__desktop .swiper-slide-active');
        videos = Array.from(activeSlide?.querySelectorAll('video') || []);
      }

      videos.forEach((video) => {
        if (video.classList.contains('hide-mobile') && isMobile) return;
        if (video.classList.contains('hide-pc') && !isMobile) return;

        try {
          video.pause();
          video.currentTime = 0;
          const playPromise = video.play();
          if (playPromise?.catch) {
            playPromise.catch(() => {});
          }
        } catch (error) {}
      });
    }
  }

  if (!window.customElements.get('yg-tabs-video')) {
    window.customElements.define('yg-tabs-video', YGTabsVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
